import * as R from 'ramda';

// renameKeys :: {a: b} -> {a: *} -> {b: *}
const renameKeys = R.curry((keysMap, obj) =>
  R.reduce((acc, key) => R.assoc(keysMap[key] || key, obj[key], acc), {}, R.keys(obj))
);

const transformCompartment = {
  volume: R.o(parseInt, R.replace(/\D/g, '')),
};

const transformations = {
  compartments: R.map(R.evolve(transformCompartment)),
  driver: R.prop('driverId'),
  location: R.prop('locationId'),
  trailer: R.prop('trailerId'),
};

export default R.compose(
  renameKeys({
    driver: 'driverId',
    location: 'locationId',
    trailer: 'trailerId',
  }),
  R.evolve(transformations)
);
